
import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
     
     GET_INDICADOR_VARIABLES: async function(data) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"sistema_municipios/"+data.idmunicipio+"/indicador_variables/" ,
          responseType: 'json', 
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },








    CREAR_INDICADOR_VARIABLES: async function(data) {



      
      var result =  await axios
        ({
          method: 'POST',
          url: this.$store.state.baseapi+"indicador_variables/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          //QUITAR COMILLAS SOLO EN DATA 
          abreviasion:data.abreviasion,
          idsecretaria:data.idsecretaria, 
          iddepartamento:data.iddepartamento, 
          descripcion:data.descripcion,
          indicador_unidad_medidas_id:data.indicador_unidad_medidas_id, 
          indicador_fuentes_informacions_id:data.indicador_fuentes_informacions_id, 
          idmunicipio:data.idmunicipio
              
               
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },





    EDITAR_INDICADOR_VARIABLES: async function(data) {




      
      var result =  await axios
        ({
          method: 'PUT',
          url: this.$store.state.baseapi+"indicador_variables/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
            'abreviasion':data.abreviasion,
             'descripcion':data.descripcion,
             indicador_unidad_medidas_id:data.indicador_unidad_medidas_id,
             indicador_fuentes_informacions_id:data.indicador_fuentes_informacions_id, 
             idsecretaria:data.idsecretaria, 
             iddepartamento:data.iddepartamento, 
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },

    ELIMINAR_INDICADOR_VARIABLES: async function(data) {




      
      var result =  await axios
        ({
          method: 'delete',
          url: this.$store.state.baseapi+"indicador_variables/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },
    },
  }